import axios from 'axios';
import {
	checkTokenExpiration,
	//actionLogoutUser,
	actionCognitoSignout,
} from 'pages/auth/actions.js'
//import cookie from 'react-cookies'
import {
	baseApiUrl,
	//banner,
} from './urls.js';
//import {
	//useSelector,
	//useDispatch,
//} from 'react-redux';
import { store } from 'index.js';

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "XCSRF-TOKEN";

//const hostname = window && window.location && window.location.hostname;

//console.log('hostname',hostname)
//https://daveceddia.com/multiple-environments-with-react/

//axios.defaults.withCredentials = true;

const API = axios.create({
	baseURL: baseApiUrl,
});//create instance

API.interceptors.request.use(function (config) {
	//const tokens = useSelector(state => state.tokens);
	const state = store.getState();
	//console.log('state.tokens',state.tokens)

	//const accessToken = cookie.load('accessToken') || ''
	//if (accessToken !=''){
	checkTokenExpiration();
	//}
//:UNDO:
	const newHeaders = { ...config.headers, Authorization: `Bearer ${state.tokens.access_token}` }
	//const newHeaders = { ...config.headers }
	const newConfig = { ...config, headers: newHeaders}
	//console.log('newConfig', newConfig)
	//return config;
	return newConfig;
}, function (error) {
	return Promise.reject(error);
});

API.interceptors.response.use(function (response) {
	// Any status code that lie within the range of 2xx cause this function to trigger
	return response;
}, function (error) {
	//:TODO: not getting Access-Control-Allow-Headers back from options call
	//const dispatch = useDispatch()
	console.log('error', error)
	//console.log('e json', error.toJSON());
	//some error - probably token expired so log out - need 401 status but not accessable
	//actionLogoutUser();
	actionCognitoSignout();
	//dispatch(actionSetMessage('User login failed - logged out!'))
	return Promise.reject(error);
});
export default API